{
  "add": "Добавить",
  "age": {
    "range": {
      "ADULT": "Взрослый",
      "BABY": "Младенец",
      "CHILD": "Ребенок",
      "SENIOR": "Пожилой человек",
      "TURNING_SENIOR": "Предпенсионный возраст",
      "YOUNG_ADULT": "Молодой человек",
      "YOUTH": "Подросток"
    },
    "unknown": "Возраст неизвестен",
    "years": "Возраст: {{ years }}"
  },
  "ages": {
    "ADULT": "(21–63) Взрослый",
    "BABY": "(0–1) Младенец",
    "CHILD": "(1–5) Ребенок",
    "SENIOR": "(65+) Пожилой человек",
    "TURNING_SENIOR": "(64) Предпенсионный возраст",
    "YOUNG_ADULT": "(19–20) Молодой человек",
    "YOUTH": "(6–18) Подросток"
  },
  "back": "Назад",
  "cancel": "Отмена",
  "childCaregiverStatus": {
    "CAREGIVER": "Да",
    "NOT_CAREGIVER": "Нет"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Подходящий иммиграционный статус (грин-карта и т. д.)",
    "NOT_ANSWERED": "Предпочитаю не отвечать",
    "US_CITIZEN": "Гражданин США",
    "US_NATIONAL": "Гражданин (National) США"
  },
  "clear": "Очистить",
  "clearAddress": "Очистить адрес",
  "clearFilters": "Сбросить фильтры",
  "clinic": "Клиника",
  "close": "Закрыть",
  "continue": "Продолжить",
  "dateOfBirth": "Дата рождения",
  "datePicker": {
    "placeholder": "Выберите дату",
    "required": "Пожалуйста, выберите дату."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} день",
    "daysWithCount_other": "{{count}} дн.",
    "monthsWithCount_one": "{{count}} месяц",
    "monthsWithCount_other": "{{count}} мес.",
    "yearsWithCount_one": "{{count}} год",
    "yearsWithCount_other": "{{count}} лет"
  },
  "day": "День",
  "delete": "Удалить",
  "discardFormChangesDialog": {
    "cancelButton": "Вернуться к редактированию",
    "confirmButton": "Все равно выйти",
    "creating": "создании",
    "description": "Есть несохраненные изменения в разделе {{entity}}, который вы {{action}}. Если вы выйдете, прогресс будет потерян.",
    "entity": "данных",
    "title": "Вы уверены, что хотите выйти?",
    "updating": "редактировании"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Подтверждение иммиграционного статуса",
    "PROOF_OF_EXEMPTION": "Подтверждение освобождения",
    "PROOF_OF_EXPENSE": "Подтверждение расходов",
    "PROOF_OF_IDENTITY": "Удостоверение личности",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Подтверждение дохода и занятости",
    "PROOF_OF_INSURANCE": "Подтверждение страховки от работодателя или иной страховки",
    "PROOF_OF_RESIDENCE": "Подтверждение адреса проживания",
    "PROOF_OF_WORK": "Подтверждение работы",
    "SOCIAL_SECURITY_NUMBER": "Номер социального страхования (SSN)"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Выплаченные алименты",
    "AUTHORIZED_EMPLOYMENT_ID": "Разрешение на работу",
    "BANK_STATEMENTS": "Выписки из банка",
    "BIRTH_CERTIFICATE": "Свидетельство о рождении",
    "CHILDCARE": "Присмотр за детьми",
    "CHILDS_BIRTH_CERTIFICATE": "Свидетельство о рождении ребёнка",
    "CHILDS_PASSPORT": "Паспорт ребёнка",
    "COURT_ORDERED_STATEMENTS": "Судебные постановления",
    "DOCTORS_NOTE": "Справка от врача",
    "DRIVERS_LICENSE": "Водительское удостоверение",
    "EXPENSE_OTHER": "Другое",
    "FOSTER_CARE_VERIFICATION_LETTER": "Письмо-подтверждение о приёмной семье",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Документы об опеке или попечении",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Иммиграционные документы и одобрения",
    "INSURANCE_CARD": "Страховая карточка",
    "INSURANCE_CARRIER_INFO": "Данные страховой компании (название и адрес)",
    "INSURANCE_POLICY_NUMBER": "Номер страхового полиса",
    "IRA_CONTRIBUTIONS": "Взносы в IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Справка от работодателя",
    "MEDICAL_EXPENSE": "Медицинские расходы",
    "MEDICARE_CARD": "Карта Medicare",
    "MORTGAGE_STATEMENT": "Выписка по ипотеке",
    "MOVING_EXPENSES": "Расходы на переезд",
    "PASSPORT": "Паспорт",
    "PAY_STUBS": "Квитанции о зарплате (за последние 30 дней)",
    "PENSION_STATEMENTS": "Выписки о пенсионных начислениях",
    "PROPERTY_TAX_BILL": "Счет на налог на недвижимость",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Документы об освобождении",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Квитанция об оплате аренды или договор аренды",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Справка об учёбе или выписка оценок",
    "SIGNED_LETTER": "Подписанное письмо",
    "SIGNED_TIMESHEETS": "Подписанные табели учёта времени",
    "SNAP_TANF_VERIFICATION_LETTER": "Письмо-подтверждение SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "Карточка социального страхования (SSN)",
    "SSA_STATEMENTS": "Выписки SSA (соцобеспечение)",
    "SSDI_STATEMENTS": "Выписки SSDI (по инвалидности)",
    "STATE_ID": "Удостоверение личности штата (State ID)",
    "STUDENT_LOANS": "Студенческие кредиты",
    "TAX_RETURN": "Налоговая декларация (последняя)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Сертификат о зачислении на обучение или ученичество",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Письмо о зачислении в программу лечения",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Удостоверение или письмо о членстве в племени",
    "TUITION_FEES": "Оплата обучения",
    "UNEMPLOYMENT_STATEMENTS": "Документы о пособии по безработице",
    "USCIS_ID": "ID номер USCIS (для неграждан)",
    "UTILITY_BILL": "Счет за коммунальные услуги",
    "VA_DISABILITY_RATING_LETTER": "Письмо VA о степени инвалидности",
    "W2_FORMS": "Формы W-2",
    "descriptions": {
      "ALIMONY_PAID": "Соглашение о разводе или раздельном проживании",
      "AUTHORIZED_EMPLOYMENT_ID": "Документ о разрешении на работу от USCIS",
      "BANK_STATEMENTS": "Выписки по текущему или сберегательному счету за последние 30 дней",
      "BIRTH_CERTIFICATE": "Свидетельство о рождении в США с вашим именем и датой рождения",
      "CHILDCARE": "Выписка из банка, чек или письмо от организации по присмотру за детьми",
      "CHILDS_BIRTH_CERTIFICATE": "Свидетельство о рождении с именем и датой рождения вашего ребёнка",
      "CHILDS_PASSPORT": "Паспорт США с именем и датой рождения вашего ребёнка",
      "COURT_ORDERED_STATEMENTS": "Решение суда о выплате алиментов или компенсации работникам",
      "DOCTORS_NOTE": "Письмо от врача с описанием заболевания, инвалидности или беременности, на которых основано это освобождение",
      "DRIVERS_LICENSE": "Действующие права с вашим именем, датой рождения и адресом",
      "EXEMPTION_SSA_STATEMENTS": "Письмо с указанием пособия соцобеспечения человека, за которым вы ухаживаете",
      "EXEMPTION_SSDI_STATEMENTS": "Письмо с указанием пособия по инвалидности человека, за которым вы ухаживаете",
      "EXPENSE_OTHER": "Решение суда или письменное соглашение с указанием суммы платежа",
      "FOSTER_CARE_VERIFICATION_LETTER": "Письмо от службы приёмных семей вашего штата, подтверждающее ваш статус и возраст",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Решение суда или документы об опеке, подтверждающие, что вы законный опекун ребёнка",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Разрешение на работу, виза или иной документ USCIS, подтверждающий ваш статус",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Свидетельство о рождении с вашим именем и датой рождения",
      "IMMIGRATION_PASSPORT": "Паспорт с вашим именем и датой рождения",
      "INSURANCE_CARD": "Лицевая и обратная стороны карты с названием компании и номером полиса",
      "INSURANCE_CARRIER_INFO": "Документ с названием и адресом страховой компании",
      "INSURANCE_POLICY_NUMBER": "Документ, в котором указан номер вашего полиса или ID участника",
      "IRA_CONTRIBUTIONS": "Выписка из вашего банка или от поставщика IRA",
      "I_20": "Бумажная форма из вашей учебной организации, подтверждающая, что вы можете учиться в США",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Письмо, подтверждающее вашу работу и размер оплаты",
      "MEDICAL_EXPENSE": "Выписка из банка, счет или чек от вашего врача, больницы или аптеки",
      "MEDICARE_CARD": "Карта Medicare, подтверждающая ваше участие в Medicare Part A и/или B",
      "MORTGAGE_STATEMENT": "Выписка по ипотеке за последние 60 дней с вашим адресом",
      "MOVING_EXPENSES": "Чеки за переезд и письмо от вашего работодателя",
      "PASSPORT": "Паспорт США с вашим именем и датой рождения",
      "PAY_STUBS": "Квитанции о зарплате за последние 30 дней с указанием дохода и работодателя",
      "PENSION_STATEMENTS": "Документ с указанием суммы вашей ежемесячной пенсии",
      "PROPERTY_TAX_BILL": "Счет на налог на имущество с вашим адресом",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Документы с датой вашего освобождения из тюрьмы",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Квитанция или договор аренды с вашим текущим адресом",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Письмо или выписка оценок, подтверждающие, что вы учитесь не менее чем на половину учебной нагрузки",
      "SIGNED_LETTER": "Письмо, подтверждающее обучение, учёбу, ученичество или общественные работы",
      "SIGNED_TIMESHEETS": "Табели, подписанные вашим работодателем или руководителем, с указанием отработанных часов",
      "SNAP_TANF_VERIFICATION_LETTER": "Письмо из вашего офиса SNAP или TANF, подтверждающее, что вы выполняете их требования к работе",
      "SOCIAL_SECURITY_CARD": "Карточка с вашим именем и 9-значным номером социального страхования",
      "SSA_STATEMENTS": "Письмо с указанием суммы вашего ежемесячного пособия от соцобеспечения",
      "SSDI_STATEMENTS": "Письмо с указанием суммы вашего ежемесячного пособия по инвалидности",
      "STATE_ID": "Действующее удостоверение личности штата с вашим именем, датой рождения и адресом",
      "STUDENT_LOANS": "Выписка из вашего банка или от организации, обслуживающей кредит",
      "TAX_RETURN": "Полная налоговая декларация за прошлый год",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Сертификат или письмо, подтверждающие ваше зачисление в программу обучения или ученичества",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Письмо, подтверждающее, что вы проходите программу лечения от наркотической или алкогольной зависимости",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Удостоверение члена племени или письмо, подтверждающее ваше членство",
      "TUITION_FEES": "Чек или счет из вашей учебной организации",
      "UNEMPLOYMENT_STATEMENTS": "Письмо с указанием суммы вашего пособия по безработице",
      "USCIS_ID": "Грин-карта, разрешение на работу или свидетельство о гражданстве",
      "UTILITY_BILL": "Счет за последние 60 дней (свет, газ, вода или телефон) с вашим адресом",
      "VA_DISABILITY_RATING_LETTER": "Письмо VA, подтверждающее вашу степень инвалидности 100%",
      "W2_FORMS": "Последняя форма W-2 с указанием вашего работодателя и зарплаты"
    }
  },
  "documents": {
    "choosePhoto": "Выбрать фото",
    "takePhoto": "Сделать фото"
  },
  "done": "Готово",
  "edit": "Изменить",
  "email": "Электронная почта",
  "error": "Ошибка",
  "errorFallback": {
    "description": "Возникла проблема при загрузке этой страницы.",
    "resetCta": "Попробовать снова",
    "title": "Что-то пошло не так."
  },
  "errors": {
    "appleSsoNotSupported": "Вход через Apple недоступен. Пожалуйста, выберите другой способ.",
    "emptyHomeAddress": "Введите и выберите домашний адрес или выберите «Нет домашнего адреса».",
    "emptyMailingAddress": "Введите и выберите почтовый адрес или выберите «Нет почтового адреса».",
    "googleSsoNotSupported": "Вход через Google недоступен. Пожалуйста, выберите другой способ.",
    "invalidEmail": "Введите правильный адрес эл. почты (например, name@example.com).",
    "selectValidOption": "Пожалуйста, выберите правильный вариант.",
    "unableToCreateApplications": "Мы не смогли отправить ваши заявки. Проверьте интернет и попробуйте снова.",
    "unauthenticated": "Пожалуйста, войдите, чтобы продолжить.",
    "unauthorized": "У вас нет доступа. Если это ошибка, напишите нам на support@pointcare.com.",
    "unknown": "Что-то пошло не так. Пожалуйста, попробуйте снова."
  },
  "exit": "Выход",
  "female": "Женский",
  "filesWithCount_one": "{{count}} файл",
  "filesWithCount_other": "{{count}} файлов",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Страховка от работодателя",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Другое",
    "PRIVATE": "Частная страховка или Маркетплейс ACA",
    "TRICARE": "TRICARE (военная страховка)",
    "VA": "Медицинская программа для ветеранов (VA)"
  },
  "home": "Главная",
  "householdMember": "Член семьи",
  "listConnector": " и ",
  "listSeparator": ", ",
  "loading": "Загрузка...",
  "login": {
    "checkYourEmail": "Проверьте вашу почту {{email}} — там ссылка для входа.",
    "placeholder": "name@example.com",
    "sendEmail": "Отправить письмо"
  },
  "longDateFormat": "D MMMM YYYY",
  "male": "Мужской",
  "maritalStatus": {
    "COMMON_LAW": "Фактический брак",
    "DIVORCED": "В разводе",
    "MARRIED": "В браке",
    "NEVER_MARRIED": "Никогда не состоял(а) в браке",
    "REGISTERED_DOMESTIC_PARTNER": "Зарегистрированное партнерство",
    "SEPARATED": "Проживают отдельно",
    "WIDOWED": "Вдовец / Вдова"
  },
  "marketplace": "Маркетплейс ACA",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Часть C)",
    "NOT_SURE": "Не уверен(а)",
    "ORIGINAL": "Части A и B (Original)"
  },
  "member_one": "{{count}} участник",
  "member_other": "{{count}} участников",
  "month": "Месяц",
  "next": "Далее",
  "no": "Нет",
  "noResults": "Ничего не найдено",
  "noneOfTheAbove": "Ничего из перечисленного",
  "ok": "ОК",
  "open": "Открыть",
  "or": "или",
  "pagination": {
    "goToFirstPage": "На первую страницу",
    "goToLastPage": "На последнюю страницу",
    "goToNextPage": "На следующую страницу",
    "goToPreviousPage": "На предыдущую страницу",
    "morePages": "Еще страницы",
    "pagination": "Навигация",
    "rowsPerPage": "Строк на странице",
    "rowsResults": "с {{from}} по {{to}} из {{total}}",
    "showingPrefix": "Показано "
  },
  "payFrequency": {
    "ANNUALLY": "Раз в год",
    "BI_WEEKLY": "Каждые 2 недели",
    "MONTHLY": "Раз в месяц",
    "WEEKLY": "Раз в неделю"
  },
  "pdfViewer": {
    "loading": "Загрузка документа..."
  },
  "program_one": "{{count}} программа",
  "program_other": "{{count}} программ",
  "progressIndicator": "Готово: {{progress}} из {{total}}",
  "relationships": {
    "CHILD": "Ребенок",
    "FOSTER_CHILD": "Приемный ребенок",
    "GRANDCHILD": "Внук / Внучка",
    "GRANDPARENT": "Дедушка / Бабушка",
    "OTHER": "Другое",
    "PARENT": "Родитель",
    "PARTNER": "Партнер",
    "SIBLING": "Брат / Сестра",
    "SPOUSE": "Супруг(а)",
    "STEPCHILD": "Пасынок / Падчерица"
  },
  "required": "Это поле обязательно для заполнения.",
  "returnToDashboard": "Вернуться на главную",
  "save": "Сохранить",
  "saveChanges": "Сохранить изменения",
  "share": "Поделиться",
  "sidebar": {
    "title": "Боковая панель",
    "toggle": "Свернуть/развернуть панель"
  },
  "signOut": "Выйти",
  "skip": "Пропустить",
  "stepIndicator": "Шаг {{currentStep}} из {{totalSteps}}",
  "submit": "Отправить",
  "tabs": {
    "home": "Главная"
  },
  "taxFilingStatus": {
    "HEAD": "Глава семьи",
    "JOINTLY": "В браке, совместная декларация",
    "NON_FILER": "Не подаю декларацию",
    "SEPARATELY": "В браке, раздельные декларации",
    "SINGLE": "Холост / Не замужем",
    "WIDOWER": "Вдовец / Вдова с ребенком на иждивении"
  },
  "theme": "Тема",
  "time": {
    "am": "AM",
    "pm": "PM"
  },
  "undo": "Отменить",
  "unknown": "Неизвестно",
  "uploadButton": {
    "title": "Загрузить файл или сделать фото"
  },
  "validation": {
    "atLeastOneOption": "Пожалуйста, выберите хотя бы один вариант.",
    "genericError": "Не удалось. Пожалуйста, попробуйте снова.",
    "invalidCode": "Код не совпадает. Проверьте его или запросите новый.",
    "invalidEmail": "Введите правильный адрес эл. почты (например, name@example.com).",
    "invalidNumber": "Пожалуйста, введите правильное число.",
    "invalidPassword": "Пароль неверен. Пожалуйста, попробуйте еще раз.",
    "invalidPhone": "Пожалуйста, введите 10-значный номер телефона.",
    "invalidSsn": "Номер социального страхования должен содержать только цифры (без дефисов и пробелов).",
    "invalidSsnFormat": "Это недействительный номер социального страхования. Пожалуйста, проверьте его и попробуйте снова.",
    "invalidSsnLength": "Пожалуйста, введите 9-значный номер социального страхования.",
    "numberMustBeNonNegative": "Пожалуйста, введите число от нуля и выше.",
    "passwordMismatch": "Пароли не совпадают.",
    "requiredField": "Пожалуйста, заполните это поле.",
    "requiredFields": "Пожалуйста, заполните все обязательные поля.",
    "requiredNonNegative": "Пожалуйста, введите число от нуля и выше.",
    "requiredPassword": "Пожалуйста, введите ваш пароль.",
    "unknown": "Что-то пошло не так. Пожалуйста, попробуйте снова."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Введите адрес электронной почты, чтобы завершить вход",
    "verify": "Подтвердить",
    "verifyError": "Мы не смогли проверить вашу ссылку для входа. Возможно, ее срок истек. Пожалуйста, запросите новую."
  },
  "whoApplies": "К кому это относится?",
  "whoIsApplying": "Кто подает заявку?",
  "year": "Год",
  "yes": "Да",
  "zoom": "Масштаб",
  "zoomIn": "Увеличить",
  "zoomOut": "Уменьшить",
  "zoomReset": "Сбросить масштаб"
}
